import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-23/task-03";

const task: Slide = {
  title:
    "If a very high level of protection from noise is to be achieved, a building must be designed to meet the requirements for:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
